module.exports = __webpack_public_path__ + "static/media/contract-garantie-MRH.65385c9d.svg";